export const environment = {
  production: true,
  apiRoot: 'https://maxstorage.akip.cz',
  apiMapyCom: '2As3-bsnPEBm1SyEQCMgagoKr6hiQ8y1lzRBw1-CiGQ',
  eshopAdmin: 'https://admin.maximuminventory.cz'
};



// WEBPACK FOOTER //
// /app/src/environments/environment.ts